var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapTargetSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,15h-3.0506592C28.4608765,8.6300659,23.3699341,3.5391235,17,3.0506592V0h-2v3.0506592 C8.6300659,3.5391235,3.5391235,8.6300659,3.0506592,15H0v2h3.0506592C3.5391235,23.3699341,8.6300659,28.4608765,15,28.9493408V32 h2v-3.0506592C23.3699341,28.4608765,28.4608765,23.3699341,28.9493408,17H32V15z M17,26.9493408V24h-2v2.9493408 C9.7319946,26.4717407,5.5282593,22.2680054,5.0506592,17H8v-2H5.0506592C5.5282593,9.7319946,9.7319946,5.5282593,15,5.0506592V8h2 V5.0506592C22.2680054,5.5282593,26.4717407,9.7319946,26.9493408,15H24v2h2.9493408 C26.4717407,22.2680054,22.2680054,26.4717407,17,26.9493408z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapTargetSmall);
export default __webpack_public_path__ + "static/media/map-target--small.17365b6f349ecd1e825db0e62fe3043a.svg";
export { ForwardRef as ReactComponent };